import * as React from 'react';
const NegativeTrendIcon = (props) => (
	<svg fill="none" height={57} width={56} xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect fill="#FFE0E0" height={56} rx={28} width={56} y={0.5} />
		<path
			d="M18 18.5v17c0 1.66 1.34 3 3 3h17"
			stroke="#FF4B41"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
		/>
		<path
			d="m37 33.5-4.59-5.36c-.76-.88-2.11-.94-2.93-.11l-.95.95c-.82.82-2.17.77-2.93-.11L21 23.5"
			stroke="#FF4B41"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
		/>
	</svg>
);
export default NegativeTrendIcon;
